import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardsDashboardComponent } from "./components/cards-dashboard/cards-dashboard.component";
import { PendingBranchesTodayComponent } from "./components/pending-branches-today/pending-branches-today.component";
import { PendingBranchesPreviousDaysComponent } from "./components/pending-branches-previous-days/pending-branches-previous-days.component";
import { DashboardService } from './services/dashboard.service';
import { rxResource } from '@angular/core/rxjs-interop';
import { PaginationService } from 'src/app/shared/components/pagination/pagination.service';
import { PaginationComponent } from "src/app/shared/components/pagination/pagination.component";
import { BranchesService } from '@features/admin/branches/services/branches.service';
import { BranchesDifferencesTableComponent } from "./components/branch-differences-table/branches-differences-table.component";
import { DatesService } from '@features/reports/components/dates-filter/dates.service';

@Component({
    selector: 'app-dashboard',
    imports: [CommonModule, FormsModule, CardsDashboardComponent, PendingBranchesTodayComponent, PendingBranchesPreviousDaysComponent, PaginationComponent, BranchesDifferencesTableComponent],
    templateUrl: './dashboard.html'
})
export class Dashboard {

    dashboardService = inject(DashboardService);
    branchesService = inject(BranchesService);
    paginationService = inject(PaginationService);
    filterDatesService = inject(DatesService);


    pendingBranchTodayResource = rxResource({
        request: () => {
            const today = this.getTodayLocal();

            return {
                status: 'PENDING',
                from: today,
                to: today,
                page: this.paginationService.getCurrentPage('today')(),
                per_page: this.paginationService.getRows('today')(),
            };
        },
        loader: ({ request }) =>
            this.dashboardService.getPendingBranch({
                status: request.status,
                from: request.from,
                to: request.to,
                page: request.page,
                per_page: request.per_page,
            }),
    });


    pendingBranchPreviousDayResource = rxResource({
        request: () => {
            const yesterday = this.getDateDaysAgo(1);
            const sevenDaysAgo = this.getDateDaysAgo(7);

            return {
                status: 'PENDING',
                from: sevenDaysAgo,
                to: yesterday,
                page: this.paginationService.getCurrentPage('previous')(),
                per_page: this.paginationService.getRows('previous')(),
            };
        },
        loader: ({ request }) =>
            this.dashboardService.getPendingBranch({
                status: request.status,
                from: request.from,
                to: request.to,
                page: request.page,
                per_page: request.per_page,
            }),
    });



    differencesBranchTodayResource = rxResource({
        request: () => {
            const selectedDate = this.filterDatesService.datesArray()[0] ?? this.getTodayLocal();

            return {
                status: 'RECEIVED',
                from: selectedDate,
                to: selectedDate,
                page: this.paginationService.getCurrentPage('today')(),
                per_page: this.paginationService.getRows('today')(),
            };
        },
        loader: ({ request }) =>
            this.dashboardService.getPendingBranch({
                status: request.status,
                from: request.from,
                to: request.to,
                page: request.page,
                per_page: request.per_page,
            }),
    });

    branchesCountResource = rxResource({
        loader: () => this.dashboardService.branchesCount(),
    });

    private getTodayLocal(): string {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private getDateDaysAgo(days: number): string {
        const date = new Date();
        date.setDate(date.getDate() - days);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    todayTotal = computed(() =>
        this.pendingBranchTodayResource.value()?.pagination?.total ?? 0
    );

    previousTotal = computed(() =>
        this.pendingBranchPreviousDayResource.value()?.pagination?.total ?? 0
    );

    branchesTotal = computed(() => this.branchesCountResource.value()?.data ?? 0);

    refreshData() {
        this.pendingBranchPreviousDayResource.reload();
    }
}
